import React, { Component } from "react";
import {
    Panel,
    Row,
    Col,
    ControlLabel,
    Button,
    Modal,
    FormControl,
    Table,
    Radio,
    InputGroup,
    ProgressBar,
    Label,
    Checkbox,
    FormGroup
} from "react-bootstrap";
import Select from "react-select";
import "react-select/dist/react-select.css";
import debounce from "lodash.debounce";
import Pagination from "react-js-pagination";
import {
    ToastContainer,
    toast
} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import cloneDeep from "lodash.clonedeep";
import moment from "moment";
import DateTime from "react-datetime";
import "style/react-datetime.css";
import axios              from "axios";
import FileSaver          from 'file-saver';
import socketIOClient     from "socket.io-client";

import {
    IS_VALID
} from "utils";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

export default class EVoucherReport extends Component {
    constructor (props) {
        super(props);

        this.campaignCategoryComponentRef = React.createRef();
        this.exportComponentRef = React.createRef();

        this.state = {
            isLoadingAction: false,
            showModal: false,
            formType: "",
            formTitle: "",

            campaignCategory: [],
            evoucher: [],
            evScannerUser: [],
            outlet: [],

            memberId: [],
            cardType: [],
            status: [],
            claimStartDate: "",
            claimEndDate: "",
            redeemStartDate: "",
            redeemEndDate: "",

            statusOption: [
                {
                    label: "Claimed",
                    value: "CLAIMED"
                },
                {
                    label: "Redeemed",
                    value: "REDEEMED"
                },
                {
                    label: "Expired",
                    value: "EXPIRED"
                }
            ],

            showModalExport: false,
            isHideClaimedData: false
        };

        this.loadOptions = this.loadOptions.bind(this);
        this.generateReport = this.generateReport.bind(this);
    }

    loadOptions (input, cb, className) {
        let {
            evoucher
        } = this.state;

        let query,
            objItem;

        if (className === "User") {
            query = new Parse.Query(Parse.User);

            query
            .equalTo("userType", "MERCHANT")
            .matches("name", input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i')
            .ascending("name");

            let user = Parse.User.current();
            
            if (
                user &&
                user.get("userType")
            ) {
                // let userQuery = evoucher.relation("evScannerUser").query();

                if (user.get("userType") === "PARTNER") {
                    query.containedIn("objectId", user.get("evScannerUserConfig") ? user.get("evScannerUserConfig") : []); // userQuery
                }

                // query.matchesKeyInQuery("objectId", "objectId", userQuery);
            }

            objItem = (item) => {
                return {
                    label: item.get("name"),
                    value: item.id
                };
            };
        } else if (className === "MemberDetail") {
            query = new Parse.Query(className);

            query.matches("memberId", input, "i")
            .exists("memberId")
            .notEqualTo("memberId", "");

            objItem = (item) => {
                return {
                    label: item.get("memberId"),
                    value: item.get("memberId")
                }
            };
        } else if (className === "VoucherCardType") {
            query = new Parse.Query(className);

            query
            .matches("name", input, "i")
            .ascending("name");

            objItem = (item) => {
                return {
                    label: item.get("name"),
                    value: item.get("name")
                }
            };
        }

        if (query) {
            query.limit(10);

            query.find()
            .then((data) => {
                return data.map(objItem);
            }).then((data) => {
                cb(null, {options: data});
            })
            .catch((err) => {
                console.log('loadOptions error');
                console.log(err);

                cb(null, {options: [] });
            });
        } else {
            cb(null, {options: [] });
        }
    }

    generateReport () {
        let {
            campaignCategory,
            evoucher,
            evScannerUser,
            outlet,

            memberId,
            cardType,
            status,
            claimStartDate,
            claimEndDate,
            redeemStartDate,
            redeemEndDate
        } = this.state;


        if (campaignCategory.length === 0) { // !IS_VALID(campaignCategory)
            toast.error("Campaign Category is required.");
        } else if (evoucher.length === 0) { // !IS_VALID(evoucher)
            toast.error("EVoucher is required.");
        } else if (
            IS_VALID(claimStartDate) &&
            !moment(claimStartDate, "MMM DD, YYYY hh:mm A", true).isValid()
        ) {
            toast.error("Please select a valid Claimed Start Timestamp.");
        } else if (
            IS_VALID(claimEndDate) &&
            !moment(claimEndDate, "MMM DD, YYYY hh:mm A", true).isValid()
        ) {
            toast.error("Please select a valid Claimed End Timestamp.");
        } else if (
            IS_VALID(redeemStartDate) &&
            !moment(redeemStartDate, "MMM DD, YYYY hh:mm A", true).isValid()
        ) {
            toast.error("Please select a valid Redeemed Start Timestamp.");
        } else if (
            IS_VALID(redeemEndDate) &&
            !moment(redeemEndDate, "MMM DD, YYYY hh:mm A", true).isValid()
        ) {
            toast.error("Please select a valid Redeemed End Timestamp.");
        } else {
            this.setState({
                showModalExport: true
            });
        }
    }

    loadOptions_outlet (input, cb) {
        let params = {
            input,
            userIdArray: false
        };

        let user = Parse.User.current();
            
        if (
            user &&
            user.get("userType") &&
            user.get("userType") === "PARTNER"
        ) {
            params.userIdArray = user.get("evScannerUserConfig") ? user.get("evScannerUserConfig") : [];
        }
        
        axios.post(
            WEB_PATH + "/EVoucherReport/outlet",
            params
        )
        .then((res) => {
            cb(null, {options: res.data});
        })
        .catch((err) => {
            console.log("loadOptions_outlet error");
            console.log(err);

            cb(null, {options: []});
        });
    }

    render () {
        let {
            isLoadingAction,
            showModal,
            formType,
            formTitle,

            campaignCategory,
            evoucher,
            evScannerUser,
            outlet,

            memberId,
            cardType,
            status,
            claimStartDate,
            claimEndDate,
            redeemStartDate,
            redeemEndDate,

            statusOption,
            isHideClaimedData
        } = this.state;

        const space = {
			paddingTop: '10px',
			paddingBottom: '10px'
		};

        let requiredSpan = <span style={{ color: "red" }}>*</span>;

        return (
            <div>
                <Panel>
                    <Panel.Heading style={{
                        backgroundColor: '#D1282F',
                        color: 'white'
                    }}>
                        <h4>EVoucher Report</h4>
                    </Panel.Heading>
                    <Panel.Body>
                        <Row>
                            <Col md={6}>
                                <Row style={space}>
                                    <Col md={4}>
                                        <ControlLabel>Campaign Category {requiredSpan}</ControlLabel>
                                    </Col>
                                    <Col md={8}>
                                    {campaignCategory.length !== 0 ? (
                                            <Table striped bordered condensed hover style={{ margin: 0 }}>
                                               <tbody>
                                                {campaignCategory.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    {item.get("title") || ""}&nbsp;
                                                                </td>
                                                                <td>
                                                                    <i
                                                                        className="fa fa-times-circle fa-lg"
                                                                        style={{
                                                                            background: "white",
                                                                            borderRadius: "7px",
                                                                            cursor: "pointer",
                                                                            float: "right"
                                                                        }}
                                                                        onClick={() => {
                                                                            let clone = [...campaignCategory];

                                                                            clone.splice(index, 1);

                                                                            let clone_evoucher = [];

                                                                            for (let _evoucher of evoucher) {
                                                                                if (
                                                                                    item.id !== (_evoucher.get("campaignCategory").id)
                                                                                ) {
                                                                                    clone_evoucher.push(_evoucher);
                                                                                }
                                                                            }

                                                                            this.setState({
                                                                                campaignCategory: clone,
                                                                                evoucher: clone_evoucher
                                                                            });
                                                                        }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                               </tbody>
                                            </Table>
                                        ) : (
                                            "Select Campaign Category"
                                        )}
                                    </Col>
                                </Row>
                                <Row style={space}>
                                    <Col md={8} mdOffset={4}>
                                        <Button
                                            style={{ width: "100%" }}
                                            onClick={() => {
                                                this.setState({
                                                    showModal: true,
                                                    formType: "CAMPAIGN_CATEGORY",
                                                    formTitle: "Campaign Category"
                                                });
                                            }}
                                        >
                                            Select Campaign Category
                                        </Button>
                                    </Col>
                                </Row>
                                <Row style={space}>
                                    <Col md={4}>
                                        <ControlLabel>EVoucher {requiredSpan}</ControlLabel>
                                    </Col>
                                    <Col md={8}>
                                        {evoucher.length !== 0 ? (
                                            <Table striped bordered condensed hover style={{ margin: 0 }}>
                                               <tbody>
                                                {evoucher.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    {item.get("title") || ""}&nbsp;
                                                                </td>
                                                                <td>
                                                                    <i
                                                                        className="fa fa-times-circle fa-lg"
                                                                        style={{
                                                                            background: "white",
                                                                            borderRadius: "7px",
                                                                            cursor: "pointer",
                                                                            float: "right"
                                                                        }}
                                                                        onClick={() => {
                                                                            let clone = [...evoucher];

                                                                            clone.splice(index, 1);

                                                                            this.setState({
                                                                                evoucher: clone
                                                                            });
                                                                        }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                               </tbody>
                                            </Table>
                                        ) : (
                                            "Select EVoucher"
                                        )}
                                    </Col>
                                </Row>
                                <Row style={space}>
                                    <Col md={8} mdOffset={4}>
                                        <Button
                                            style={{ width: "100%" }}
                                            disabled={campaignCategory.length === 0}
                                            onClick={() => {
                                                this.setState({
                                                    showModal: true,
                                                    formType: "EVOUCHER",
                                                    formTitle: "EVoucher"
                                                });
                                            }}
                                        >
                                            Select EVoucher
                                        </Button>
                                    </Col>
                                </Row>
                                <Row style={space}>
                                    <Col md={4}>
                                        <ControlLabel>EV Scanner User</ControlLabel>
                                    </Col>
                                    <Col md={8}>
                                        {evoucher.length !== 0 ? (
                                            <Select.Async
                                                id="with-value"
                                                multi={true}
                                                placeholder="Select or Search..."
                                                value={evScannerUser}
                                                onChange={(value) => {
                                                    this.setState({
                                                        evScannerUser: value
                                                    });
                                                }}
                                                loadOptions={(input, cb) => this.loadOptions(input, cb, "User")}
                                            />
                                        ) : (
                                            <Select
                                                id="no-value"
                                                disabled={true}
                                                placeholder="Select or Search..."
                                            />
                                        )}
                                    </Col>
                                </Row>
                                <Row style={space}>
                                    <Col md={4}>
                                        <ControlLabel>Outlet</ControlLabel>
                                    </Col>
                                    <Col md={8}>
                                        {evoucher.length !== 0 ? (
                                            <Select.Async
                                                id="outlet-with-value"
                                                multi={true}
                                                placeholder="Select or Search..."
                                                value={outlet}
                                                onChange={(value) => {
                                                    this.setState({
                                                        outlet: value
                                                    });
                                                }}
                                                loadOptions={(input, cb) => this.loadOptions_outlet(input, cb,)}
                                            />
                                        ) : (
                                            <Select
                                                id="outlet-no-value"
                                                disabled={true}
                                                placeholder="Select or Search..."
                                            />
                                        )}
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={6}>
                                <Row style={space}>
                                    <Col md={4}>
                                        <ControlLabel>Member ID</ControlLabel>
                                    </Col>
                                    <Col md={8}>
                                        <Select.Async
                                            multi={true}
                                            placeholder="Select or Search..."
                                            value={memberId}
                                            onChange={(value) => {
                                                this.setState({
                                                    memberId: value
                                                });
                                            }}
                                            loadOptions={(input, cb) => this.loadOptions(input, cb, "MemberDetail")}
                                        />
                                    </Col>
                                </Row>
                                <Row style={space}>
                                    <Col md={4}>
                                        <ControlLabel>Card Type</ControlLabel>
                                    </Col>
                                    <Col md={8}>
                                        <Select.Async
                                            multi={true}
                                            placeholder="Select or Search..."
                                            value={cardType}
                                            onChange={(value) => {
                                                this.setState({
                                                    cardType: value
                                                });
                                            }}
                                            loadOptions={(input, cb) => this.loadOptions(input, cb, "VoucherCardType")}
                                        />
                                    </Col>
                                </Row>
                                <Row style={space}>
                                    <Col md={4}>
                                        <ControlLabel>Status</ControlLabel>
                                    </Col>
                                    <Col md={8}>
                                        <Select
                                            multi={true}
                                            disabled={isHideClaimedData}
                                            value={status}
                                            onChange={(value) => {
                                                this.setState({
                                                    status: value
                                                });
                                            }}
                                            options={statusOption}
                                        />
                                    </Col>
                                </Row>
                                {!isHideClaimedData ? (
                                    <Row style={space}>
                                        <Col md={4}>
                                            <ControlLabel>Claimed Timestamp</ControlLabel>
                                        </Col>
                                        <Col md={8}>
                                            <InputGroup>
                                                <DateTime
                                                    dateFormat="MMM DD, YYYY"
                                                    timeFormat="hh:mm A"
                                                    value={claimStartDate}
                                                    onChange={(datetime) => {
                                                        this.setState({
                                                            claimStartDate: datetime
                                                        });
                                                    }}
                                                    inputProps={{
                                                        placeholder: "Start Date",
                                                        style: {
                                                            position: "initial",
                                                            borderRadius: "4px 0 0 4px"
                                                        }
                                                    }}
                                                />
                                                <InputGroup.Addon>TO</InputGroup.Addon>
                                                <DateTime
                                                    dateFormat="MMM DD, YYYY"
                                                    timeFormat="hh:mm A"
                                                    value={claimEndDate}
                                                    onChange={(datetime) => {
                                                        this.setState({
                                                            claimEndDate: datetime
                                                        });
                                                    }}
                                                    inputProps={{
                                                        placeholder: "End Date",
                                                        style: {
                                                            position: "initial",
                                                            borderRadius: "0 4px 4px 0"
                                                        }
                                                    }}
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                ) : (
                                    ""
                                )}
                                <Row style={space}>
                                    <Col md={4}>
                                        <ControlLabel>Redeemed Timestamp</ControlLabel>
                                    </Col>
                                    <Col md={8}>
                                        <InputGroup>
                                            <DateTime
                                                dateFormat="MMM DD, YYYY"
                                                timeFormat="hh:mm A"
                                                value={redeemStartDate}
                                                onChange={(datetime) => {
                                                    this.setState({
                                                        redeemStartDate: datetime
                                                    });
                                                }}
                                                inputProps={{
                                                    placeholder: "Start Date",
                                                    style: {
                                                        position: "initial",
                                                        borderRadius: "4px 0 0 4px"
                                                    }
                                                }}
                                            />
                                            <InputGroup.Addon>TO</InputGroup.Addon>
                                            <DateTime
                                                dateFormat="MMM DD, YYYY"
                                                timeFormat="hh:mm A"
                                                value={redeemEndDate}
                                                onChange={(datetime) => {
                                                    this.setState({
                                                        redeemEndDate: datetime
                                                    });
                                                }}
                                                inputProps={{
                                                    placeholder: "End Date",
                                                    style: {
                                                        position: "initial",
                                                        borderRadius: "0 4px 4px 0"
                                                    }
                                                }}
                                            />
                                        </InputGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} style={{ textAlign: "center" }}>
                                <Button
                                    bsStyle="primary"
                                    disabled={isLoadingAction}
                                    onClick={() => this.generateReport()}
                                >
                                    GENERATE
                                </Button>
                            </Col>
                        </Row>
                    </Panel.Body>
                </Panel>
                <Modal
                    show={showModal}
                    backdrop="static"
                    onHide={() => {
                        this.setState({ showModal: false });
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{formTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <CampaignCategoryEVoucherForm
                            ref={(ref) => {
                                this.CampaignCategoryEVoucherFormRef = ref;
                            }}
                            {...{
                                campaignCategory,
                                evoucher,
                                formType
                            }}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            bsStyle="primary"
                            onClick={() => {
                                if (
                                    this.CampaignCategoryEVoucherFormRef &&
                                    this.CampaignCategoryEVoucherFormRef.getSelected
                                ) {
                                    let selected = this.CampaignCategoryEVoucherFormRef.getSelected();

                                    if (selected.length === 0) { // null
                                        toast.error("Please select a " + formTitle);
                                    } else {
                                        let stateToUpdate = {
                                            showModal: false,

                                            [formType === "EVOUCHER" ? "evoucher" : "campaignCategory"]: [ ...(formType === "EVOUCHER" ? evoucher : campaignCategory), ...selected]
                                        }

                                        // if (formType !== "EVOUCHER" ) {
                                        //     stateToUpdate.evoucher = [];
                                        // }

                                        this.setState(stateToUpdate);
                                    }
                                }
                            }}
                        >
                            SELECT
                        </Button>
                        <Button
                            onClick={() => {
                                this.setState({ showModal: false });
                            }}
                        >
                            CLOSE
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    bsSize={null}
                    backdrop="static"
                    show={this.state.showModalExport}
                    onHide={() => {
                        if (
                            this.exportComponentRef.current &&
                            this.exportComponentRef.current.isLoading()
                        ) {
                            return;   
                        }
                        
                        this.setState({
                            showModalExport: false
                        });
                    }}
                >
                     <Modal.Header closeButton>
                        <Modal.Title>EXPORT EVOUCHER REPORT</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ExportComponent
                            ref={this.exportComponentRef}
                            closeModal={() => {
                                this.setState({ showModalExport: false });
                            }}
                            {...{
                                campaignCategory,
                                evoucher,
                                evScannerUser,
                                outlet,

                                memberId,
                                cardType,
                                status,
                                claimStartDate,
                                claimEndDate,
                                redeemStartDate,
                                redeemEndDate
                            }}
                        />
                    </Modal.Body>
                </Modal>
                <ToastContainer/>
            </div>
        );
    }

    componentDidMount () {
        let user = Parse.User.current();
            
        if (
            user &&
            user.get("userType") &&
            user.get("userType") === "PARTNER" &&
            user.get("isHideClaimedData") === true
        ) {
            this.setState({
                isHideClaimedData: true,
                status: [this.state.statusOption[1]]
            });
        }
    }
}

class CampaignCategoryEVoucherForm extends Component {
    constructor (props) {
        super(props);

        this.state = {
            search: "",
            status: null,
            statusOption: [
                {
                    label: "Published",
                    value: "PUBLISH"
                },
                {
                    label: "Expired",
                    value: "EXPIRED"
                }
            ],
            campaignStartDate: "",
            campaignEndDate: "",
            selected: {}, // props.formType === "EVOUCHER" ? {} : "",
            list: [],
            isLoading: false,
            page: 1,
            total: 0
        };

        this.getList = this.getList.bind(this);
        this.getSelected = this.getSelected.bind(this);

        this.getListDelayCallback = debounce(this.getList, 1000);
    }

    getList (page = 1) {
        let {
            search,
            status,
            campaignStartDate,
            campaignEndDate
        } = this.state;

        let {
            formType,
            campaignCategory,
            evoucher
        } = this.props;

        this.setState({
            selected: {}, // formType === "EVOUCHER" ? {} : "",
            isLoading: true,
            page
        });

        let query;
        
        if (formType === "EVOUCHER") {
            query = new Parse.Query("EVoucher");

            query.include("campaignCategory");
            query.containedIn("campaignCategory", campaignCategory);
            query.notEqualTo("status", "DRAFT");

            let user = Parse.User.current();
            
            if (
                user &&
                user.get("userType") &&
                user.get("userType") === "PARTNER"
            ) {
                query.containedIn("evScannerUser", (user.get("evScannerUserConfig") ? user.get("evScannerUserConfig") : []).map((id) => new Parse.User({ id })));
            }

            if (evoucher.length !== 0) {
                query.notContainedIn("objectId", evoucher.map((item) => item.id));
            }
        } else {
            query = new Parse.Query("CampaignCategory");

            query.notEqualTo("status", "DRAFT");
            
            let user = Parse.User.current();
            
            if (
                user &&
                user.get("userType") &&
                user.get("userType") === "PARTNER"
            ) {
                let evoucherQuery = new Parse.Query("EVoucher");

                evoucherQuery.containedIn("evScannerUser", (user.get("evScannerUserConfig") ? user.get("evScannerUserConfig") : []).map((id) => new Parse.User({ id })));

                query.matchesKeyInQuery("objectId", "campaignCategory.objectId", evoucherQuery);
            }

            if (campaignCategory.length !== 0) {
                query.notContainedIn("objectId", campaignCategory.map((item) => item.id));
            }
        }

        if (
            search !== "" &&
            search.trim() !== ""
        ) {
            query.matches("title", search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), "i");
        }

        if (status) {
            query.equalTo("status", status.value);
        }

        if (
            campaignStartDate &&
            moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true ).isValid()
        ) {
            query.greaterThanOrEqualTo("campaignStartDate", moment(campaignStartDate).toDate());
        }

        if (
            campaignEndDate &&
            moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true ).isValid()
        ) {
            query.lessThanOrEqualTo("campaignEndDate", moment(campaignEndDate).toDate());
        }
        
        query
        .skip((page - 1) * 10)
        .limit(10)
        .select(
        "campaignCategory",
        "title",
        "status",
        "campaignStartDate",
        "campaignEndDate"
        )
        .descending("createdAt");

        let countQuery = cloneDeep(query);

        countQuery
        .skip(0)
        .limit(-1);
        
        Promise.all([
            query.find(),
            countQuery.count()
        ])
        .then(([ data, count ]) => {
            let stateToUpdate = {
                isLoading: false,
                list: data,
                total: count
            };

            // if (formType === "EVOUCHER") {
                let selected = {};

                for (let index = 0; index < data.length; index++) {
                    selected[`${index}`] = false;
                }

                stateToUpdate.selected = selected
            // }

            this.setState(stateToUpdate);
        })
        .catch((err) => {
            this.setState({
                isLoading: false,
                list: [],
                total: 0
            });
        });
    }

    getSelected () {
        let {
            selected,
            list,
            isLoading
        } = this.state;

        let {
            formType
        } = this.props;


        // if (formType === "EVOUCHER") {
            if (isLoading) {
                return [];
            }

            let _selected = [];

            for (let key in selected) {
                if (selected[key]) {
                    _selected.push(
                        list[key]
                    );
                }
            }

            return _selected;
        // } else {
        //     if (isLoading) {
        //         return null;
        //     } else if (selected === "") {
        //         return null;
        //     } else if (!IS_VALID(list[selected])) {
        //         return null;
        //     }
    
        //     return list[selected];
        // }
    }

    render () {
        let {
            search,
            status,
            statusOption,
            campaignStartDate,
            campaignEndDate,
            selected,
            list,
            isLoading,
            page,
            total
        } = this.state;

        let {
            formType
        } = this.props;

        let tr = [];

        if (isLoading) {
            tr = (
                <tr>
                <td
                    colSpan={15}
                    style={{
                    textAlign: 'center',
                    color: '#808080'
                    }}
                    >
                    <i className="fa fa-spinner fa-spin fa-3x"></i>
                </td>
                </tr>
            );
        } else if (list.length === 0) {
            tr = (
                <tr>
                <td
                    colSpan={15}
                    style={{
                    textAlign: 'center',
                    color: '#808080'}}
                    >
                    No Data Available
                </td>
                </tr>
            );
        } else {
            let renderStatus = (value) => {
                let renderValue = value;

                if (IS_VALID(value)) {
                    switch (value.toUpperCase()) {
                        case "PUBLISH":
                            renderValue = <span style={{ color: "green" }}>{value}</span>;
                        break;
                        case "EXPIRED":
                            renderValue = <span style={{ color: "red" }}>{value}</span>
                        break;
                        case "DRAFT":
                            renderValue = <span style={{ color: "gray" }}>{value}</span>
                        break;
                    }
                }

                return renderValue;
            };

            tr = list.map((item, index) => {
                return (
                    <tr>
                        <td>
                            {/* {formType === "EVOUCHER" ? ( */}
                                <Checkbox
                                    style={{ margin: "0" }}
                                    checked={selected[index] || false}
                                    onChange={(e) => {
                                        let clone = {...selected};

                                        clone[index] = e.target.checked;

                                        this.setState({ selected: clone });
                                    }}
                                />
                            {/* ) : (
                                <Radio
                                    style={{ margin: "0" }}
                                    checked={selected === index}
                                    onChange={(e) => {
                                        this.setState({ selected: index });
                                    }}
                                />
                            )} */}
                        </td>
                        <td>{item.get("title")}</td>
                        <td>{renderStatus(item.get("status"))}</td>
                        <td style={{ whiteSpace: "nowrap" }}>{moment(item.get("campaignStartDate")).format("MMM-DD-YYYY hh:mm:ss A")}</td>
                        <td style={{ whiteSpace: "nowrap" }}>{moment(item.get("campaignEndDate")).format("MMM-DD-YYYY hh:mm:ss A")}</td>
                    </tr>
                );
            })
        }

        let isCheckedAll = false;

        let checkboxItemArray = [];

        for (let key in selected) {
            checkboxItemArray.push(
                selected[key]
            );
        }

        isCheckedAll = checkboxItemArray.length !== 0 ? checkboxItemArray.every((checked) => checked === true) : false;

        return (
            <div>
                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <ControlLabel>Title</ControlLabel>
                            <FormControl
                                type="text"
                                placeholder="Search"
                                value={search}
                                onChange={(e) => {
                                    this.setState({ search: e.target.value });
                                    this.getListDelayCallback();
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <ControlLabel>Status</ControlLabel>
                            <Select
                                value={status}
                                onChange={(value) => {
                                    this.setState({
                                        status: value
                                    });
                                    this.getListDelayCallback();
                                }}
                                options={statusOption}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Campaign Date</ControlLabel>
                            <InputGroup>
                                <DateTime
                                    dateFormat="MMM DD, YYYY"
                                    timeFormat="hh:mm A"
                                    value={campaignStartDate}
                                    onChange={(datetime) => {
                                        this.setState({
                                            campaignStartDate: datetime
                                        });

                                        this.getListDelayCallback();
                                    }}
                                    inputProps={{
                                        placeholder: "Start Date",
                                        style: {
                                            position: "initial",
                                            borderRadius: "4px 0 0 4px"
                                        }
                                    }}
                                />
                                <InputGroup.Addon>TO</InputGroup.Addon>
                                <DateTime
                                    dateFormat="MMM DD, YYYY"
                                    timeFormat="hh:mm A"
                                    value={campaignEndDate}
                                    onChange={(datetime) => {
                                        this.setState({
                                            campaignEndDate: datetime
                                        });


                                        this.getListDelayCallback();
                                    }}
                                    inputProps={{
                                        placeholder: "End Date",
                                        style: {
                                            position: "initial",
                                            borderRadius: "0 4px 4px 0"
                                        }
                                    }}
                                />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
                <div
                    style={{ overflowX: "auto" }}
                >
                    <Table striped bordered condensed hover>
                        <thead>
                        <tr>
                            <th>
                                {/* {formType === "EVOUCHER" ? ( */}
                                    <Checkbox
                                        style={{ margin: "0" }}
                                        disabled={list.length === 0}
                                        checked={isCheckedAll}
                                        onChange={(e) => {
                                            let clone = {...selected};

                                            for (let index = 0; index < list.length; index++) {
                                                clone[`${index}`] = e.target.checked;
                                            }

                                            this.setState({
                                                selected: clone
                                            });
                                        }}
							        />
                                {/* ) : (
                                    ""
                                )} */}
                            </th>
                            <th>Title</th>
                            <th>Status</th>
                            <th>Campaign Start Date</th>
                            <th>Campaign End Date</th>
                        </tr>
                        </thead>
                        <tbody>
                            {tr}
                        </tbody>
                    </Table>
                </div>
                <div>Total Records: {total}</div>
                <Pagination
                    activePage={page}
                    itemsCountPerPage={10}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={(pageNumber) => {
                        this.getList(pageNumber);
                    }}
                />
            </div>
        );
    }

    componentDidMount () {
        this.getList();
    }
}

class ExportComponent extends Component {
    constructor (props) {
        super(props);
    
        this.state = {
        isExportStarting: false,
        isExporting: false,
        isExportSuccess: false,
        isExportError: false,
        exportPercentage: 0,
        fileConfig: {
            filename: "",
            blob: ""
        },
        errorMessage: ""
        };

        this.exportData = this.exportData.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
        this.isLoading = this.isLoading.bind(this);
    }

    async exportData () {
        let {
            campaignCategory,
            evoucher,
            evScannerUser,
            outlet,

            memberId,
            cardType,
            status,
            claimStartDate,
            claimEndDate,
            redeemStartDate,
            redeemEndDate
        } = this.props;

        this.setState({
            isExportStarting: true
        });

        let params = {
            campaignCategoryId: campaignCategory.map((item) => item.id),
            evoucherId: evoucher.map((item) => item.id),
            evScannerUserIdArray: evScannerUser.map(item => item.value),
            outletArray: outlet.map(item => item.value),

            memberIdArray: memberId.map(item => item.value),
            cardTypeArray: cardType.map(item => item.value),
            status: status.map((item) => item.value),
            claimStartDate: claimStartDate ? moment(claimStartDate).format() : "",
            claimEndDate: claimEndDate ? moment(claimEndDate).format() : "",
            redeemStartDate: redeemStartDate ? moment(redeemStartDate).format() : "",
            redeemEndDate: redeemEndDate ? moment(redeemEndDate).format() : ""
        };

        let user = Parse.User.current();

        if (
            user &&
            user.get("userType") &&
            user.get("userType") === "PARTNER"
        ) {
            params.isHideFinanceData = typeof user.get("isHideFinanceData") === "boolean" ? user.get("isHideFinanceData") : false;

            if (evScannerUser.length === 0) {
                try {
                    let userQuery = new Parse.Query(Parse.User); // evoucher.relation("evScannerUser").query();

                    userQuery.containedIn("objectId", user.get("evScannerUserConfig") ? user.get("evScannerUserConfig") : []);

                    let users = await userQuery.find();

                    params.evScannerUserIdArray = users.map((item) => item.id);
                } catch (error) {
                    // 
                }
            }
        }

        axios.post(
            WEB_PATH + "/EVoucherReport/export",
            params,
            {
                timeout: 30000
            }
        )
        .then((res) => {
            let {
                fileName,
                socketNspId
            } = res.data;

            this.setState({
                isExportStarting: false,
                isExporting: true
            });

            let io = socketIOClient(
                WEB_PATH,
                {
                    transports: ["websocket"],
                    path: "/socket.io",
                    query: {
                        nspId: socketNspId
                    },
                    secure: true
                }
            );

            let listenerName = "export-evoucher-report-socket";

            io.on(
                listenerName,
                (data) => {
                    let {
                        status,
                        progress,
                        fileName,
                        fileType,
                        message
                    } = data;
                    if (status === "PROGRESS") {
                        this.setState({
                            exportPercentage: progress
                        });
                    } else if (status === "DONE") {
                        io.off(listenerName);
                        io.close();

                        axios.get(
                        WEB_PATH + "/EVoucherReport/download/" + `${fileName}.${fileType}`,
                            {
                                responseType: "arraybuffer"
                            }
                        )
                        .then((res2) => {
                            let blob = new Blob([res2.data], { type: `application/${fileType === 'xlsx' ? 'vnd.ms-excel' : 'zip'}` }),
                                filename = `EVoucher Report ${moment().format("MMM DD YYYY hh:mm A")}.${fileType}`;
            
                            this.setState({
                                isExporting: false,
                                isExportSuccess: true,
                                exportPercentage: 100,
                                fileConfig: {
                                    filename: filename,
                                    blob: blob
                                }
                            });
            
                            FileSaver.saveAs(blob, filename);
                        })
                        .catch((err) => {
                            let errorMessage = err.message;
            
                            if (
                                err.response &&
                                err.response.data &&
                                ("TextDecoder" in window)
                            ) {
                                let enc = new TextDecoder("utf-8");
                                let arr = new Uint8Array(err.response.data);
                                
                                let data = JSON.parse(enc.decode(arr)) || {};
            
                                if (
                                    data.error &&
                                    data.error.message
                                ) {
                                    errorMessage = data.error.message;
                                }
                            }
                            
                            this.setState({
                                isExporting: false,
                                isExportError: true,
                                errorMessage
                            });
                        });
                    } else if (status === "ERROR") {
                        io.off(listenerName);
                        io.close();
                        
                        this.setState({
                            isExporting: false,
                            isExportError: true,
                            errorMessage: message
                        });
                    }
                }
            );
        })
        .catch((err) => {
            let errorMessage = err.message;

            if (
                err.response &&
                err.response.data &&
                typeof err.response.data === "string"
            ) {
                errorMessage = err.response.data;
            }

            this.setState({
                isExportStarting: false,
                isExportError: true,
                errorMessage
            });
        });
    }

    downloadFile () {
        let {
            fileConfig
        } = this.state;

        let {
            filename,
            blob
        } = fileConfig

        if (IS_VALID(filename) && IS_VALID(blob)) {
            FileSaver.saveAs(blob, filename);
        }
    }

    isLoading () {
        let {
            isExportStarting,
            isExporting
        } = this.state;

        return isExportStarting || isExporting;
    }

    render () {
        let {
            isExportStarting,
            isExporting,
            isExportSuccess,
            isExportError,
            exportPercentage,
            errorMessage
        } = this.state;

        let {
            closeModal
        } = this.props;

        return (
            <div>
                {
                    !isExporting &&
                    !isExportSuccess &&
                    !isExportError ? (
                        [
                        <p>Exporting of User may take some time depending on the number of records.</p>,
                        <p style={{ textAlign: "center" }}>
                            {isExportStarting ? <span><i className="fa fa-spinner fa-spin fa-4x" /> </span> : ""}
                        </p>
                        ]
                    ) : (
                        ""
                    )
                }
                {
                    isExporting ? (
                        [
                        <p>This may take some time depending on the number of records.</p>,
                        <ProgressBar
                            active
                            striped
                            bsStyle="success"
                            now={exportPercentage}
                            label={`${exportPercentage}%`}
                        />
                        ]
                    ) : isExportSuccess || isExportError ? (
                        isExportSuccess ? (
                        <div style={{ textAlign: "center" }}>
                            <Button
                                bsStyle="success"
                                content="DOWNLOAD FILE"
                                onClick={this.downloadFile}
                            >
                                DOWNLOAD FILE
                            </Button>
                        </div>
                        ) : (
                        [
                            <h3 style={{ textAlign: "center", color: "red" }}>Something went wrong.</h3>,
                            <h4 style={{ textAlign: "center"}}>{errorMessage}</h4>,
                            <div style={{ textAlign: "center" }}>
                            <Button
                                bsStyle="primary"
                                onClick={() => {
                                closeModal();
                                }}>
                                CLOSE
                            </Button>
                            </div>
                        ]
                        )
                    ) : (
                        ""
                    )
                }
            </div>
        );
    }
    
    componentDidMount () {
            this.exportData();
    }
}



// WEBPACK FOOTER //
// ./components/EVoucherReport/index.js